import { browserHelper } from 'lib/helpers/browser-helper.class.js';
import { match } from 'ts-pattern';
import { ScreenPlatform, ScreenResult, ScreenSize } from './screen.models.js';

export function getScreenFromUserAgent(userAgent: string): ScreenResult {
	const userAgentPlatform = browserHelper.getBrowserInfo(userAgent).platform?.toLowerCase() ?? '';

	const { screenSize, platform } = match(userAgentPlatform)
		.returnType<{
			readonly screenSize: ScreenSize;
			readonly platform: ScreenPlatform;
		}>()
		.when(
			(m) => m.includes('desktop'),
			() => ({
				screenSize: 'Desktop',
				platform: 'desktop'
			})
		)
		.when(
			(m) => m.includes('tablet'),
			() => ({
				screenSize: 'Tablet',
				platform: 'tablet'
			})
		)
		.otherwise(() => {
			return {
				screenSize: 'Mobile',
				platform: 'mobile'
			};
		});

	const screenResult: ScreenResult = {
		isDesktopExtraView: false,
		isDesktopView: screenSize === 'Desktop',
		isTabletView: screenSize === 'Tablet',
		isMobileView: screenSize === 'Mobile',
		screenSize: screenSize,
		platform: platform,
		userAgent: userAgent
	};

	return screenResult;
}
